
import { defineComponent, getCurrentInstance } from 'vue';

import { sendLog } from '@/common/radar';
import { header } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';

import Container, { AI_SETTING_PAGE_NAME_ENUM } from './components/container.vue';

export enum POLICY_ENUM {
    PRIVACY_POLICY = 'privacy',
    TERMS_OF_SERVICE = 'service',
}

export default defineComponent({
    components: { Container },
    layout(ctx) {
        return ctx.$pwaLayout || 'default';
    },
    setup() {
        const { proxy } = (getCurrentInstance() as { proxy: any }) || {};

        const SettingsGroup = [
            {
                title: 'Terms of Service',
                k18nKey: 'k_326754',
                handler: () => {
                    sendLog({
                        name: 'AGREEMENT_BUTTON',
                        type: 'click',
                        value: {
                            button_type: 'Terms of Service',
                        },
                    });
                    proxy?.$router.push(`/aichat/setting/policy/${POLICY_ENUM.TERMS_OF_SERVICE}`);
                },
            },
            {
                title: 'Privacy Policy',
                k18nKey: 'k_326756',
                handler: () => {
                    sendLog({
                        name: 'AGREEMENT_BUTTON',
                        type: 'click',
                        value: {
                            button_type: 'Privacy Policy',
                        },
                    });
                    proxy?.$router.push(`/aichat/setting/policy/${POLICY_ENUM.PRIVACY_POLICY}`);
                },
            },
        ];

        return {
            SettingsGroup,
            AI_SETTING_PAGE_NAME_ENUM,
        };
    },

    asyncData(ctx) {
        if (process.server) {
            const { startup } = ctx?.store?.state || {};
            setCommonParamsCookiesInServer({
                ctx,
                bucket: startup?.bucket,
                host: ctx.req.headers.host,
                countryInfo: startup?.countryInfo,
            });
        }
        return {
            title: ctx?.i18n?.t?.('terms_policies'),
        };
    },

    head() {
        return header(this);
    },
});
